import React, { useState } from "react";
import { Send, Check, Link2 } from "lucide-react";

// Абсолютный URL для шеринга (canonical, на проде — https://portal.popovexpert.ru/...)
function absoluteUrl(path) {
  if (typeof window === "undefined") return path;
  return `${window.location.origin}${path}`;
}

export default function ShareButtons({ path, title }) {
  const [copied, setCopied] = useState(false);
  const url = absoluteUrl(path);
  const text = title || "Современный Врач";

  const tg = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
  const vk = `https://vk.com/share.php?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`;
  const wa = `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback
      window.prompt("Скопируйте ссылку:", url);
    }
  };

  const btn = {
    display: "inline-flex", alignItems: "center", gap: 6, textDecoration: "none",
    borderRadius: 8, padding: "6px 12px", fontSize: "0.85rem", fontWeight: 600,
    border: "none", cursor: "pointer", color: "#fff",
  };

  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", margin: "14px 0" }}>
      <span style={{ fontSize: "0.85rem", color: "#888", marginRight: 2 }}>Поделиться:</span>
      <a href={tg} target="_blank" rel="noopener noreferrer" style={{ ...btn, background: "#229ED9" }}><Send size={14} strokeWidth={2.2} /> Telegram</a>
      <a href={vk} target="_blank" rel="noopener noreferrer" style={{ ...btn, background: "#0077FF" }}>VK</a>
      <a href={wa} target="_blank" rel="noopener noreferrer" style={{ ...btn, background: "#25D366" }}>WhatsApp</a>
      <button onClick={copy} style={{ ...btn, background: copied ? "#15803d" : "#6b7280", marginTop: 0 }}>
        {copied ? <><Check size={14} strokeWidth={2.4} /> Скопировано</> : <><Link2 size={14} strokeWidth={2.2} /> Ссылка</>}
      </button>
    </div>
  );
}
